import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/authAction";

const initialState = {
	isLoading: false,
	isError: false,

	authForm: {}
};
const actionHandlers = {
	// Authorize
	[action.initSignIn]: createMutateReducer(draft => {
		draft.isLoading = false;
		draft.isError = false;
	}),
	[action.sendSignIn.request]: createMutateReducer((draft, { email }) => {
		draft.isLoading = true;
		draft.isError = false;

		draft.authForm.email = email;
	}),
	[action.sendSignIn.success]: createMutateReducer(draft => {
		draft.isLoading = false;
	}),
	[action.sendSignIn.error]: createMutateReducer(draft => {
		draft.isLoading = false;
		draft.isError = true;
	}),

	// Forgot
	[action.sendForgot.request]: createMutateReducer((draft, { email }) => {
		draft.isLoading = true;
		draft.isError = false;

		draft.authForm.email = email;
	}),
	[action.sendForgot.success]: createMutateReducer(draft => {
		draft.isLoading = false;
	}),
	[action.sendForgot.error]: createMutateReducer(draft => {
		draft.isLoading = false;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
